import type { FC } from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { Aligner } from '@alfa-bank/site-aligner';

import { Spinner } from '../../components/spinner';
import { fetchCurrentStep } from '../../store';
import type { TDispatch } from '../../store';

import type { TEsiaAnalysisStepDesktop } from './model';
import { defaultEsiaAnalysisSettings, FETCH_DELAY } from './config/default-values';
import { useInterval } from './hooks/use-interval';

export const EsiaAnalysisStepDesktop: FC<TEsiaAnalysisStepDesktop> = ({
    description = defaultEsiaAnalysisSettings.description,
}) => {
    const dispatch = useDispatch<TDispatch>();
    const intervalFetchCurrentStep = async () => {
        await dispatch(fetchCurrentStep());
    };

    useInterval(intervalFetchCurrentStep, FETCH_DELAY);

    return (
        <Aligner>
            <Text styler={{ marginTop: 0, marginBottom: 32 }} view="primary-medium">
                {description}
            </Text>
            <Spinner />
        </Aligner>
    );
};
